<script setup>
import { useI18n } from 'vue-i18n';
import BackButton from 'dashboard/components/widgets/BackButton.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    required: true,
    type: String,
  },
  headerDescription: {
    type: String,
    default: '',
  },
  hasBackButton: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const handlePrint = () => window.print();
</script>

<template>
  <section class="flex flex-col gap-1 pt-10 pb-5 print:pt-4 print:pb-2">
    <div v-if="hasBackButton" class="print:hidden">
      <BackButton />
    </div>
    <div class="flex justify-between items-start w-full gap-5">
      <div class="flex flex-col gap-2">
        <div>
          <span
            class="text-xl font-medium text-n-slate-12 print:text-slate-900"
          >
            {{ headerTitle }}
          </span>
          <p
            v-if="headerDescription"
            class="text-n-slate-12 mt-2 print:text-slate-700"
          >
            {{ headerDescription }}
          </p>
        </div>
      </div>
      <div class="flex flex-shrink-0 items-center gap-2">
        <V4Button
          class="print:hidden"
          :label="t('REPORT.PRINT')"
          icon="i-lucide-printer"
          size="sm"
          color="slate"
          variant="outline"
          @click="handlePrint"
        />
        <div class="print:hidden">
          <slot />
        </div>
      </div>
    </div>
  </section>
</template>
